// extracted by mini-css-extract-plugin
export default {"content":"hz-layouts-auth-layout-components-page-main-index-content"};